import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ShortNumberPipe} from './short-number.pipe';
import { AmountPipe } from './amount.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [ShortNumberPipe, AmountPipe],
    exports: [ShortNumberPipe, AmountPipe]
})
export class PipesModule {}
